export const APP_VERSION = process.env.REACT_APP_VERSION as string;
export const SERVER_URL = process.env.REACT_APP_SERVER_URL as string;
export const WEB_SOCKET_URL = process.env.REACT_APP_WEB_SOCKET_URL as string;
export const REGION = process.env.REACT_APP_REGION as string;
export const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID as string;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID as string;
export const IDENTITY_POOL_ID = process.env.REACT_APP_IDENTITY_POOL_ID as string;
export const IDENTITY_POOL_LOGIN = process.env.REACT_APP_IDENTITY_POOL_LOGIN as string;
export const STRIPE_PK = process.env.REACT_APP_STRIPE_PK as string;
export const PURCHASE_PRICE = process.env.REACT_APP_PURCHASE_PRICE as string;
export const MENTAL_CAPACITY_ANALYSIS_PRICE = process.env.REACT_APP_MENTAL_CAPACITY_ANALYSIS_PRICE as string;
export const VIDEO_BUCKET = process.env.REACT_APP_VIDEO_BUCKET as string;
export const LANDING_URL = process.env.REACT_APP_LANDING_URL as string;
export const GTM_ID = process.env.REACT_APP_GTM_ID as string;
// The cookie banner shows wherever a container is configured (live) and, for testing, on staging
// and local builds too; there it stores the choice and loads nothing.
export const CONSENT_PREVIEW = process.env.REACT_APP_CONSENT_PREVIEW === 'true';
export const IS_DEV = process.env.REACT_APP_IS_DEV as string;